import React from "react";

import { EXPERTS_TITLE } from "../constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MultiLevelMenu
} from "../MultiLevelMenu";

const Experts = () => (
  <MultiLevelMenu title={EXPERTS_TITLE}>
    <ListTitle>{EXPERTS_TITLE}</ListTitle>
    <MenuList isSubMenu>
      <li>
        <ItemText href="/manage/experts/connections">Connections</ItemText>
      </li>
    </MenuList>
  </MultiLevelMenu>
);

Experts.propTypes = {};

Experts.defaultProps = {};

export default Experts;
